import React, { useEffect, useState, useRef } from "react"
import { withRouter, useParams } from "react-router-dom"
import * as issuesAction from "../../store/b3BlcmF0aW9uc0/actions"
import PropTypes from "prop-types"
import { connect, useSelector } from "react-redux"
import {
  Col,
  UncontrolledTooltip,
  Input,
  Button,
  Row,
  // Badge,
  Label,
  Table,
  Badge,
} from "reactstrap"
import { ToastContainer, toast } from "react-toastify"
import Modal from "react-bootstrap/Modal"
import { isEmpty } from "lodash"
import moment from "moment"
import SimpleReactValidator from "simple-react-validator"

import Select from "react-select"

const OperationsIssuesTab = (props) => {
  const { dispatch } = props
  let { id } = useParams()

  useEffect(() => {
    dispatch(issuesAction.loadIssues({ leadId: id }))
    dispatch(issuesAction.loadRecordsMetaData())
  }, [])
  const update = useSelector((state) => state.operationsFollowUp)
  const { issuesDetails, recordsMetaData } = update
  console.log(issuesDetails)
  //simple validatioator
  const simpleValidator = useRef(new SimpleReactValidator())

  const [, forceUpdate] = useState()
  //dateformat
  const sessionUpdate = useSelector((specificstate) => specificstate.session)
  const { user = [] } = sessionUpdate

  //date format from localstorage
  const authUser = localStorage.getItem("authUser")

  const dateLogin = JSON.parse(authUser)

  const setDate =
    !isEmpty(dateLogin) && dateLogin.setting && dateLogin.setting.dateFormate
      ? dateLogin.setting.dateFormate.toUpperCase()
      : !isEmpty(user) && user.setting && user.setting.dateFormate
        ? user.setting.dateFormate.toUpperCase()
        : []

  const dateFormat = !isEmpty(setDate) && setDate ? setDate : ""
  console.log(dateFormat)

  //issues form initiial state
  const [issuesData, setIssuesData] = useState({
    _id: "",
    issueDescription: "",
    followUpComments: "",
    nextFollowUpDate: "",
    sollutionOffered: "",
  })
  const [department, setDepartment] = useState([])
  const [poc, setPoc] = useState([])
  const [currentStatus, setCurrentStatus] = useState([])

  const handleChange = async (e) => {
    setIssuesData({ ...issuesData, [e.target.name]: e.target.value })
  }
  const [issuesForm, setIssuesForm] = useState(false)
  //add issues api function
  const addIssues = () => {
    if (simpleValidator.current.allValid()) {
      let issueData = {
        leadId: id,
        department: department.value,
        issuesDescription: issuesData.issueDescription,
        internalFollowupComment: issuesData.followUpComments,
        nextFollowupDate: issuesData.nextFollowUpDate
          ? moment(issuesData.nextFollowUpDate).format("YYYY-MM-DD")
          : "",
        poc: poc.length > 0 ? poc.map((data) => data.value) : [],
        solutionOffered: issuesData.sollutionOffered,
        currentStatus: "Pending",
      }
      dispatch(issuesAction.addIssues(issueData))
      setTimeout(() => {
        toast.success("Records Added Successfully", {
          position: toast.POSITION.TOP_RIGHT,
        })
        setIssuesForm(false)
        // clearFollowupModal()
        dispatch(issuesAction.loadIssues({ leadId: id }))
      }, 1500)
    } else {
      simpleValidator.current.showMessages()
      forceUpdate(1)
      setIssuesForm(true)
    }
  }
  //edit issues
  const [isEdit, setIsEdit] = useState(false)

  const editIssues = (issues) => {
    setIsEdit(true)
    setIssuesForm(true)
    setIssuesData({
      _id: issues._id,
      issueDescription: issues.issuesDescription,
      followUpComments: issues.internalFollowupComment,
      nextFollowUpDate: moment(issues.nextFollowupDate).format("YYYY-MM-DD"),
      sollutionOffered: issues.solutionOffered,
    })
    const departmentValue =
      !isEmpty(recordsMetaData) &&
      recordsMetaData.departmentOptions.find(
        (val) => val.value === issues.department
      ).label
    setDepartment({
      label: departmentValue ? departmentValue.toString() : "",
      value: issues.department,
    })

    // const empId = issues.poc && issues.poc.map((m) => m)
    // const empName = empId.map((emp) => {
    //   const empLabel =
    //     !isEmpty(recordsMetaData) &&
    //     recordsMetaData.employeeOptions
    //       .find((lab) => lab.value === emp)
    //       .label.toString()
    //   return empLabel
    // })
    // setPoc({
    //   label: empName ? empName : "",
    //   value: empId
    // })
    const empId = issues?.poc ? issues.poc.map((m) => m) : []

    const pocData = !isEmpty(empId) && !isEmpty(recordsMetaData)
      ? empId.map((emp) => {
        const empOption = recordsMetaData?.employeeOptions?.find((opt) => opt?.value === emp)
        return empOption ? { label: empOption.label || '', value: empOption.value || '' } : null // Handle undefined label or value
      }).filter(Boolean) // Remove any null values from the array
      : []

    // Set poc as an array of { label, value } objects or an empty array if no valid data
    setPoc(pocData)
  }

  const updateIssues = () => {
    if (simpleValidator.current.allValid()) {
      let issueData = {
        _id: issuesData._id,
        leadId: id,
        department: department.value,
        issuesDescription: issuesData.issueDescription,
        internalFollowupComment: issuesData.followUpComments,
        nextFollowupDate: issuesData.nextFollowUpDate
          ? moment(issuesData.nextFollowUpDate).format("YYYY-MM-DD")
          : "",
        poc: poc.length > 0 ? poc.map((data) => data.value) : [],
        solutionOffered: issuesData.sollutionOffered,
        currentStatus: currentStatus.value,
      }
      dispatch(issuesAction.updateIssues(issueData))
      setTimeout(() => {
        toast.success("Records Added Successfully", {
          position: toast.POSITION.TOP_RIGHT,
        })
        setIssuesForm(false)
        // clearFollowupModal()
        dispatch(issuesAction.loadIssues({ leadId: id }))
      }, 1500)
    } else {
      simpleValidator.current.showMessages()
      forceUpdate(1)
      setIssuesForm(true)
    }
  }
  const clearForm = () => {
    setIssuesData({
      _id: "",
      issueDescription: "",
      followUpComments: "",
      nextFollowUpDate: "",
      sollutionOffered: "",
    })
    setPoc([])
    setDepartment([])
    setCurrentStatus([])
    setIsEdit(false)
  }
  //delete issues
  const [deletemodal, setDeletemodal] = useState(false)
  const [deleteIssueId, setDeleteIssueId] = useState("")
  const deleteIssues = () => {
    const deleteData = {
      issuesId: deleteIssueId,
      status: 3,
    }
    dispatch(issuesAction.deleteIssues(deleteData))
    setTimeout(() => {
      toast.success("Records Deleted Successfully", {
        position: toast.POSITION.TOP_RIGHT,
      })
      setIssuesForm(false)
      // clearFollowupModal()
      dispatch(issuesAction.loadIssues({ leadId: id }))
    }, 1500)
  }

  // const [updateIssuesData,setUpdateIssuesData] = useState({
  //     createdDate:"",
  //     lastUpdatedDate:""
  // })
  // const handleUpdateChange = (e) =>{
  //     setUpdateIssuesData({ ...updateIssuesData, [e.target.name]: e.target.value })
  // }
  return (
    <React.Fragment>
      <Row className="quote-head-content">
        <div className="d-flex flex-row">
          <p className="quote-head">
            Issues
            <span className="quote-info">
              <i
                style={{ color: "grey" }}
                id="DeliverablesInfo"
                aria-hidden="true"
                className="fa fa-info-circle ms-1"
              ></i>
              <UncontrolledTooltip placement="right" target="DeliverablesInfo">
                Issues
              </UncontrolledTooltip>
            </span>
          </p>

          <div
            className="ec-followup-btn"
            onClick={() => {
              setIssuesForm(true)
              clearForm()
            }}
          >
            Add Issues
          </div>
        </div>
        <Col md="12" lg="12" xl="12" className="mt-3">
          <Table responsive striped>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Action</th>
                <th>Department </th>
                <th style={{ minWidth: "160px" }}>Issue Description</th>
                <th style={{ minWidth: "220px" }}>
                  Internal Followup Comments
                </th>
                <th style={{ minWidth: "170px" }}>Next Followup Date</th>
                <th style={{ minWidth: "150px" }}>POC (Emp Name)</th>
                <th style={{ minWidth: "160px" }}>Solution Offered</th>
                <th style={{ minWidth: "120px" }}>Created Date</th>
                <th style={{ minWidth: "170px" }}>Last Updated Date</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {!isEmpty(issuesDetails) ? (
                issuesDetails.map((item, index) => {
                  const department =
                    !isEmpty(recordsMetaData) &&
                    recordsMetaData.departmentOptions.find(
                      (val) => val.value === item.department
                    )?.label
                  const departmentValue = department
                    ? department.toString()
                    : "--"

                  // const poc =
                  //   !isEmpty(recordsMetaData) &&
                  //   recordsMetaData.employeeOptions.find(
                  //     (val) => val.value === item.poc[0]
                  //   )?.label
                  const poc = !isEmpty(recordsMetaData) && !isEmpty(item.poc)
                    ? item.poc.map((pocItem) =>
                      recordsMetaData.employeeOptions.find((val) => val.value === pocItem)?.label
                    )
                    : []
                  const pocValue = !isEmpty(poc) ? poc.join(",") : "--"
                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>
                        <div style={{ display: "flex" }}>
                          <Button
                            type="submit"
                            onClick={() => {
                              editIssues(item)
                              //  updateVendor(data)
                            }}
                            style={{ fontSize: "8px", padding: "8px 10px" }}
                            className="btn btn-success buttons"
                            disabled={item.status == 3 ? true : false}
                          >
                            <i className="fas fa-pencil-alt icon-btn"></i>
                          </Button>
                          <Button
                            type="submit"
                            onClick={() => {
                              setDeletemodal(true)
                              setDeleteIssueId(item._id)
                            }}
                            style={{
                              fontSize: "8px",
                              marginLeft: "20px",
                              padding: "8px 10px",
                            }}
                            disabled={item.status == 3 ? true : false}
                            className="btn btn-danger buttons"
                          >
                            <i className="fas fa-trash-alt icon-btn"></i>
                          </Button>
                        </div>
                      </td>
                      <td>{departmentValue}</td>
                      <td>{item.issuesDescription}</td>
                      <td>{item.internalFollowupComment}</td>
                      <td>
                        {item.nextFollowupDate
                          ? moment(item.nextFollowupDate).format(dateFormat)
                          : ""}
                      </td>
                      <td>{pocValue}</td>
                      <td>{item.solutionOffered}</td>
                      <td>
                        {item.createdOn
                          ? moment(item.createdOn).format(dateFormat)
                          : "--"}
                      </td>
                      <td>
                        {item.updatedOn
                          ? moment(item.updatedOn).format(dateFormat)
                          : "--"}
                      </td>
                      <td>
                        <Badge
                          color={
                            item.currentStatus == "Approved"
                              ? "success"
                              : "danger"
                          }
                          style={{
                            padding: "4px 6px",
                          }}
                        >
                          {item.currentStatus ? item.currentStatus : ""}
                        </Badge>
                      </td>
                    </tr>
                  )
                })
              ) : (
                <tr key={0}>
                  <td colSpan={8} className="text-align-center">
                    No Records Found..
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Col>
      </Row>
      {issuesForm && (
        <>
          <Row className="quote-head-content">
            <Col lg="9" md="9" sm="6" xs="6" className="d-flex flex-row">
              <p className="quote-head">
                {isEdit ? "Edit Issues" : "Add Issues"}
                <span className="quote-info">
                  <i
                    style={{ color: "grey" }}
                    id="quoteInfo12"
                    aria-hidden="true"
                    className="fa fa-info-circle ms-1"
                  ></i>
                  <UncontrolledTooltip placement="right" target="quoteInfo12">
                    {isEdit ? "Edit Issues" : "Add Issues"}
                  </UncontrolledTooltip>
                </span>
              </p>
            </Col>
          </Row>
          <Row>
            <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
              <div className="d-flex justify-content-between">
                <Label className={"form-label"}>
                  {"Department"}
                  <span className="required">*</span>
                </Label>
              </div>
              <Select
                type="text"
                name="department"
                value={department}
                onChange={(e) => setDepartment(e)}
                options={
                  recordsMetaData ? recordsMetaData.departmentOptions : []
                }
                placeholder="Select Department"
                classNamePrefix="select2-selection"
              />
              <div style={{ textTransform: "capitalize" }}>
                {simpleValidator.current.message(
                  "Department",
                  department,
                  "required"
                )}
              </div>
            </Col>

            <Col md="3" lg="3" sm="12" className="mt-3">
              <div className="d-flex justify-content-between">
                <Label className="form-label" htmlFor={"Issue Description"}>
                  {"Issue Description"} {""} <span className="required">*</span>
                </Label>
              </div>
              <Input
                type="text"
                placeholder="Enter Issues Description"
                name="issueDescription"
                value={issuesData.issueDescription}
                onChange={(e) => handleChange(e)}
              />
              <div style={{ textTransform: "capitalize" }}>
                {simpleValidator.current.message(
                  "issueDescription",
                  issuesData.issueDescription,
                  "required"
                )}
              </div>
            </Col>
            <Col md="6" lg="6" sm="12" className="mt-3">
              <div className="d-flex justify-content-between">
                <Label
                  className="form-label"
                  htmlFor={"Internal Followup Comments"}
                >
                  {"Internal Followup Comments"} {""}{" "}
                  <span className="required">*</span>
                </Label>
              </div>
              <Input
                type="textarea"
                placeholder="Enter Internal Followup Comments"
                name="followUpComments"
                value={issuesData.followUpComments}
                onChange={(e) => handleChange(e)}
              />
              <div style={{ textTransform: "capitalize" }}>
                {simpleValidator.current.message(
                  "Internal Followup Comments",
                  issuesData.followUpComments,
                  "required"
                )}
              </div>
            </Col>
            <Col md="3" lg="3" sm="12" className="mt-3">
              <div className="d-flex justify-content-between">
                <Label className="form-label" htmlFor={"Next Followup Date"}>
                  {"Next Followup Date"} {""}{" "}
                  <span className="required">*</span>
                </Label>
              </div>
              <Input
                type="date"
                placeholder="Select Date"
                name="nextFollowUpDate"
                value={issuesData.nextFollowUpDate}
                // max={ticketData.toDate}
                onChange={(e) => handleChange(e)}
              />
              <div style={{ textTransform: "capitalize" }}>
                {simpleValidator.current.message(
                  "nextFollowUpDate",
                  issuesData.nextFollowUpDate,
                  "required"
                )}
              </div>
            </Col>
            <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
              <div className="d-flex justify-content-between">
                <Label className={"form-label"}>
                  {"Poc (Emp Name)"}
                  <span className="required">*</span>
                </Label>
              </div>
              <Select
                type="text"
                name="poc"
                value={poc}
                onChange={(e) => setPoc(e)}
                options={recordsMetaData ? recordsMetaData.employeeOptions : []}
                placeholder="Select Poc"
                isMulti
                classNamePrefix="select2-selection"
              />
              <div style={{ textTransform: "capitalize" }}>
                {simpleValidator.current.message("poc", poc, "required")}
              </div>
            </Col>
            <Col md="3" lg="3" sm="12" className="mt-3">
              <div className="d-flex justify-content-between">
                <Label className="form-label" htmlFor={"Issue Description"}>
                  {"Solutions Offered"} {""}{" "}
                  <span className="required">*</span>
                </Label>
              </div>
              <Input
                type="text"
                placeholder="Enter Solutions Offered"
                name="sollutionOffered"
                value={issuesData.sollutionOffered}
                onChange={(e) => handleChange(e)}
              />
              <div style={{ textTransform: "capitalize" }}>
                {simpleValidator.current.message(
                  "Solutions Offered",
                  issuesData.sollutionOffered,
                  "required"
                )}
              </div>
            </Col>
            {isEdit === true && (
              <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                <div className="d-flex justify-content-between">
                  <Label className={"form-label"}>{"Current Status"}</Label>
                </div>
                <Select
                  type="text"
                  name="currentStatus"
                  value={currentStatus}
                  onChange={(e) => setCurrentStatus(e)}
                  options={[
                    { label: "Pending", value: "Pending" },
                    { label: "Resolved", value: "Resolved" },
                  ]}
                  placeholder="Select Current Status"
                  classNamePrefix="select2-selection"
                />
              </Col>
            )}
            {/* {isEdit===true &&(  <Col md="3" lg="3" sm="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                                <Label className="form-label" htmlFor={"Next Followup Date"}>
                                    {"Created Date"} {""}{" "}
                                </Label>
                            </div>
                            <Input
                                type="date"
                                placeholder="Select Date"
                                name="createdDate"
                                value={updateIssuesData.createdDate}
                                // max={ticketData.toDate}
                                onChange={(e) => handleUpdateChange(e)}/>
                           
                        </Col>)}
                        {isEdit===true &&(  <Col md="3" lg="3" sm="12" className="mt-3">
                            <div className="d-flex justify-content-between">
                                <Label className="form-label" htmlFor={"Next Followup Date"}>
                                    {"Last Updated Date"} {""}{" "}
                                </Label>
                            </div>
                            <Input
                                type="date"
                                placeholder="Select Date"
                                name="lastUpdatedDate"
                                value={updateIssuesData.lastUpdatedDate}
                                // max={ticketData.toDate}
                                onChange={(e) => handleUpdateChange(e)}/>
                           
                        </Col>)} */}
            <Col md="12" xl="12" lg="12" className="mt-5 mb-3">
              <div style={{ float: "right" }} className="d-flex flex-row">
                <Button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => {
                    setIssuesForm(false)
                    // clearFollowupModal()
                  }}
                >
                  Cancel
                </Button>
                {isEdit ? (
                  <Button
                    type="button"
                    variant="primary"
                    className="btn btn-success mx-2"
                    onClick={() => {
                      updateIssues()
                    }}
                  >
                    Update
                  </Button>
                ) : (
                  <Button
                    type="button"
                    variant="primary"
                    className="btn btn-success mx-2"
                    onClick={(e) => {
                      addIssues(e)
                    }}
                  >
                    Submit
                  </Button>
                )}
              </div>
            </Col>
          </Row>
        </>
      )}
      {deletemodal && (
        <Modal show={deletemodal} size="md">
          <Modal.Header
            style={{
              backgroundColor: "#E40D8C",
              color: "white",
              minHeight: "65px",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            Delete Issue
          </Modal.Header>
          <Modal.Body> Are You Sure You Want To Delete This?</Modal.Body>
          <Modal.Footer>
            <div>
              <Button
                type="submit"
                onClick={() => {
                  deleteIssues()
                  setTimeout(() => {
                    setDeletemodal(false)
                  }, 500)
                }}
                style={{ fontSize: "10px", marginLeft: "20px" }}
                className="btn btn-success buttons"
              >
                {" "}
                Yes
              </Button>
              <Button
                type="submit"
                onClick={() => {
                  setDeletemodal(false)
                }}
                style={{ fontSize: "10px", marginLeft: "20px" }}
                className="btn btn-danger buttons"
              >
                {" "}
                No
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      )}
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </React.Fragment>
  )
}

OperationsIssuesTab.propTypes = {
  dispatch: PropTypes.func,
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

const mapStateToProps = () => ({
  //mapstate to prop
})
//OperationsIssuesTab
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(OperationsIssuesTab)
)
